import HttpClient from "libs/utils/HttpClient";

class SettingService {
  async searchLocation(typeSearch, keyword) {
    try {
      const response = await HttpClient.get(
        `/api/setting/location/search?typeSearch=${typeSearch}&keyword=${
          keyword || `""`
        }`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getAddress() {
    try {
      const response = await HttpClient.get(`/api/setting/address/list`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new SettingService();
